import { fetchAuthSession } from '../cognito/cognito.helper.js';
import { getAuthConfig } from '../config.js';
import { signOut } from './auth-signout.actions.js';

const fetchAuthDetails = async ({ forceRefresh = false } = {})=>{
    try {
        const session = await fetchAuthSession({
            forceRefresh
        });
        if (!session) {
            return {
                isLoggedIn: false
            };
        }
        const internalCustomerId = session.tokens?.idToken?.payload?.['custom:customer_id'] || null;
        const accessToken = session.tokens?.accessToken?.toString();
        const idToken = session.tokens?.idToken?.toString();
        const config = getAuthConfig();
        const customerIdAuthCheckEnabled = config.enableCustomerIdCheck ?? true;
        if (!internalCustomerId && customerIdAuthCheckEnabled) {
            try {
                await signOut();
            } catch (error) {
                if (config.onError) {
                    config.onError(error, {
                        context: 'fetchAuthDetails_signOut',
                        data: session.tokens?.idToken?.payload
                    });
                } else {
                    console.error('Auth signOut error:', error);
                }
            }
            const error = new Error('InternalCustomerId not found');
            if (config.onError) {
                config.onError(error, {
                    context: 'fetchAuthDetails_customerIdCheck',
                    data: session.tokens?.idToken?.payload
                });
            } else {
                console.error('Auth error:', error);
            }
            return {
                isLoggedIn: false
            };
        }
        if (!accessToken || !idToken) {
            const error = new Error('access token or id token not found at fetchAuthDetails');
            if (config.onError) {
                config.onError(error, {
                    context: 'fetchAuthDetails_tokenCheck',
                    data: {
                        message: 'Access token not found at fetchAuthDetails',
                        payload: session
                    }
                });
            } else {
                console.error('Auth error:', error);
            }
            return {
                isLoggedIn: false
            };
        }
        return {
            idToken,
            accessToken,
            isLoggedIn: true
        };
    } catch (error) {
        throw error;
    }
};

export { fetchAuthDetails };
//# sourceMappingURL=auth-action.helpers.js.map
